<template>
    <div>
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet"
            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
            crossorigin="anonymous" />
        <div class="cont">
            <h1>Impersonating</h1>
            <div class="first">
                <form class="form form--login" method="POST" action="/admin/admin_page/impersonate">
                    <input type="hidden" name="_token" :value="csrf" />
                    <div class="row">
                        <div class="one">
                            <div class="form-floating">
                                <input type="text" class="form-control" id="floatingInput" placeholder="meno"
                                    name="email" />
                                <label for="floatingInput">Email uživateľa</label>
                            </div>
                        </div>
                        <button type="submit" class="ulozit">
                            <span>Login</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            csrf: document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content"),
        };
    },
};
</script>

<style lang="scss" scoped>
.cont {
    width: 1188px;
    margin: 0 auto;
    padding: 35px 0;

    @media only screen and (max-width: 1500px) {
        width: 95%;
    }

    h1 {
        @media only screen and (max-width: 600px) {
            width: 90%;
            margin: 0 auto;
        }

        font-family: "Roboto";
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 28px;
        text-align: center;
        color: #000000;
    }

    h3 {
        width: 700px;

        @media only screen and (max-width: 600px) {
            width: 90%;
        }

        margin: 10px auto 27px auto;
        font-family: "Roboto";
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 150%;
        text-align: center;
        color: #9598a7;
    }

    .first {
        width: 480px;
        padding: 24px;
        background: #ffffff;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        margin: 0 auto;

        h3 {
            width: auto;
            margin: 0 0 19px 0;
            font-family: "Roboto";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 21px;
            color: #212541;
            text-align: left;
        }

        h4 {
            font-family: "Roboto";
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 21px;
            color: #9598a7;
            margin-bottom: 18px;

            a {
                font-family: "Roboto";
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 21px;
                color: #9598a7;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        .form-group {
            display: flex;
            align-items: center;
            margin-bottom: 0px;
        }

        label {
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212541;
        }

        input[type="checkbox"] {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            -webkit-tap-highlight-color: transparent;
            cursor: pointer;
            margin: 0px 10px 0 0px;
            background: #c7d4eb;
            border-radius: 25px;
        }

        .toggle {
            height: 22px;
            width: 40px;
            display: inline-block;
            position: relative;
            margin: 0;
            border: none;
            background: #ffffff;
            border-radius: 3px;
            transition: all 0.2s ease;

            &:focus {
                outline: 0;
            }

            &:after {
                content: "";
                position: absolute;
                top: 4px;
                left: 3px;
                width: 14px;
                height: 14px;
                border-radius: 50%;
                background: white;
                box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
                transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
            }

            &:checked {
                border-color: #2ed8b6;
                background: #2ed8b6;
            }

            &:checked:after {
                transform: translatex(20px);
            }
        }

        .info {
            position: relative;
            height: 20px;
            margin-left: 10px;

            .info_icon {
                pointer-events: all;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                float: right;

                img {
                    width: 80%;
                    height: 80%;
                }
            }

            .my_tooltip {
                bottom: 22px;
                right: -7px;
            }
        }

        .agree_tooltip {
            position: relative;
        }

        .my_tooltip {
            font-family: "Roboto";
            font-style: normal;
            font-weight: 700;
            pointer-events: none;
            opacity: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 300px;
            background: #f3385a;
            box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
            border-radius: 6px;
            font-weight: 800;
            font-size: 14px;
            line-height: 18px;
            color: #fff;
            padding: 10px;
            position: absolute;
            top: unset;
            right: 15px;
            z-index: 10000;
            transition: opacity 0.5s ease-in-out;

            &::after {
                content: "";
                width: 15px;
                height: 15px;
                background: #f3385a;
                position: absolute;
                right: 10px;
                bottom: -3px;
                transform: rotate(45deg);
                border-radius: 3px;
            }
        }
    }

    .ulozit {
        width: 480px;
        height: 55px;

        @media only screen and (max-width: 600px) {
            width: 95%;
        }

        margin: 15px auto 0 auto;
        background: #2ed8b6;
        border-radius: 4px;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        color: #ffffff;
        cursor: pointer;
        transition: 0.5s all;

        &:hover {
            background: #23caa9;
        }
    }
}

.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}

.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(0);
    }
}

@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }

    100% {
        transform: translate(24px, 0);
    }
}
</style>
